import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProductServiceType } from './product-service-status.enum';

@Injectable({

  providedIn: 'root'

})

export class ProductsAndServicesTabsNewService {

  isShowProductServiceType: ProductServiceType;
  showProductServiceType: BehaviorSubject<ProductServiceType> = new BehaviorSubject<ProductServiceType>(null)
  tabNumber: BehaviorSubject<ProductServiceType> = new BehaviorSubject<ProductServiceType>(null)

  constructor() {
  }

  setTab(event: number) {
    this.tabNumber.next(event);
  }

  getTab() {
   return this.tabNumber.asObservable();
  }

}


